import React from 'react';

import Wrapper from './styles';

const ContentBannerSection = props => <Wrapper {...props} />;

export default ContentBannerSection;
